import React, { useState } from "react";
import ArticleSchemaForm from "./ArticleSchemaForm.js";
import BreadcrumbSchemaForm from "./BreadcrumbSchemaForm.js";
import EventSchemaForm from "./EventSchemaForm.js";
import FAQSchemaForm from "./FAQPageSchemaForm.js";
import HowToSchemaForm from "./HowToSchemaForm.js";
import JobPostingSchemaForm from "./JobPostingSchemaForm.js";
import LocalBusinessSchemaForm from "./LocalBusinessSchemaForm.js";
import OrganizationSchemaForm from "./OrganizationSchemaForm.js";
import PersonSchemaForm from "./PersonSchemaForm.js";
import RecipeSchemaForm from "./RecipeSchemaForm.js";
import VideoSchemaForm from "./VideoSchemaForm.js";
import WebsiteSchemaForm from "./WebsiteSchemaForm.js";
import ProductSchemaForm from "./ProductSchemaForm.js";

const SchemaForm = () => {
  const [schemaType, setSchemaType] = useState("Article");

  const handleSchemaChange = (e) => {
    const selectedSchema = e.target.value;
    setSchemaType(selectedSchema);
  };

  const renderSchemaForm = () => {
    switch (schemaType) {
      case "Article":
        return <ArticleSchemaForm />;
      case "Breadcrumb":
        return <BreadcrumbSchemaForm />;
      case "Event":
        return <EventSchemaForm />;
      case "FAQPage":
        return <FAQSchemaForm />;
      case "HowTo":
        return <HowToSchemaForm />;
      case "JobPosting":
        return <JobPostingSchemaForm />;
      case "LocalBusiness":
        return <LocalBusinessSchemaForm />;
      case "Organization":
        return <OrganizationSchemaForm />;
      case "Person":
        return <PersonSchemaForm />;
      case "Product":
        return <ProductSchemaForm />;
      case "Recipe":
        return <RecipeSchemaForm />;
      case "Video":
        return <VideoSchemaForm />;
      case "Website":
        return <WebsiteSchemaForm />;
      default:
        return <p>Please select a schema type from the dropdown above.</p>;
    }
  };

  return (
    <div className="container mt-4">
      <h6 className="fw-bold">Which Schema would you like to create?</h6>
      <div className="mb-4">
        <select
          className="form-select bg-primary text-white w-50"
          value={schemaType}
          onChange={handleSchemaChange}
        >
          <option value="">-- Select Schema Type --</option>
          <option value="Article">Article</option>
          <option value="Breadcrumb">Breadcrumb</option>
          <option value="Event">Event</option>
          <option value="FAQPage">FAQ Page</option>
          <option value="HowTo">How-To</option>
          <option value="JobPosting">Job Posting</option>
          <option value="LocalBusiness">Local Business</option>
          <option value="Organization">Organization</option>
          <option value="Person">Person</option>
          <option value="Product">Product</option>
          <option value="Recipe">Recipe</option>
          <option value="Video">Video</option>
          <option value="Website">Website</option>
        </select>
      </div>

      <div>{renderSchemaForm()}</div>
    </div>
  );
};

export default SchemaForm;
